import { render, staticRenderFns } from "./faqs.vue?vue&type=template&id=a928279e&"
import script from "./faqs.vue?vue&type=script&lang=js&"
export * from "./faqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arthur.cruz/BRNDWGN/Projects/mz-marketing-wp/web/app/themes/mz-marketing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a928279e')) {
      api.createRecord('a928279e', component.options)
    } else {
      api.reload('a928279e', component.options)
    }
    module.hot.accept("./faqs.vue?vue&type=template&id=a928279e&", function () {
      api.rerender('a928279e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/faqs.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/faqs.vue
// module id = 81
// module chunks = 0